
export default {
    name:"terms",
    data(){
        return{

        }
    },
    head(){
    return{
      title:'Όροι χρήσης'
    }
  },
}
